import { Component, input } from '@angular/core';
import { FormControl, type FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { ProsemirrorBasicConfigDirective, WysiwygComponent } from '@core/prosemirror-legacy/webapp';
import { NameSymbolInputComponent, type SymbolEmoji } from '@core/symbol-legacy';
import {
  CheckboxComponent,
  FormFieldComponent,
  HeadingComponent,
  LabelComponent,
  ProtectedControlDirective,
} from '@core/user-interface-legacy';
import type { TellentMemberBrief } from '@tellent-ask-hr/core-types';

import { TeamMemberSelectComponent } from './team-member-select/team-member-select.component';

export interface AskTemplateForm {
  name: FormControl<string>;
  symbol: FormControl<SymbolEmoji | null>;
  descriptionJson: FormControl<object | null>;
  prioritySelectionEnabled: FormControl<boolean>;
  autoAssignments: FormControl<string[]>;
  active: FormControl<boolean>;
}

@Component({
  selector: 'ask-template-form',
  templateUrl: './ask-template-form.component.html',
  imports: [
    FormFieldComponent,
    LabelComponent,
    NameSymbolInputComponent,
    WysiwygComponent,
    ProsemirrorBasicConfigDirective,
    CheckboxComponent,
    HeadingComponent,
    ReactiveFormsModule,
    TranslatePipe,
    TeamMemberSelectComponent,
    ProtectedControlDirective,
  ],
  host: {
    class: 'rt-card',
  },
  styleUrls: ['./ask-template-form.component.less'],
})
export class AskTemplateFormComponent {
  public askTemplateForm = input.required<FormGroup<AskTemplateForm>>();
  public selectedMembers = input<TellentMemberBrief[]>([]);
  public autoAssignmentsRequired = input<boolean>(false);
  public errors = input<Record<string, Record<string, string>>>({});
}
